import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
  name: 'DashIfEmpty',
})
export class DashIfEmpty implements PipeTransform {
  transform(value: string, is529 = false): string {
    if (is529) {
      return '529 Portfolio'
    }
    return value ? value : `—`
  }
}
